
import React, { useContext, useEffect, useRef, useState } from "react";
import EventContext from "./EventContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faXmark,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
import UserContext from "../../../../UserContext";
import axios from "axios";
import { StandaloneSearchBox, LoadScript, useJsApiLoader} from '@react-google-maps/api';
import { toast } from "react-toastify";

const EditEvent = () => {
  const { editEvent, handleEditEvent, currEvent, events, setEvents,getExpiredEvents} = useContext(EventContext);
  const { userInfo } = useContext(UserContext);
  const { handleCreateEvent, createEvent } = useContext(EventContext);
  const initialMins = currEvent.duration % 60;
  const initialHrs = Math.trunc(currEvent.duration / 60);
  const [minutes, setMinutes] = useState(initialMins);
  const [hours, setHours] = useState(initialHrs);
  const [address, setAddress] = useState(currEvent.location.address);
  const [city, setCity] = useState(currEvent.location.city);
  const [pincode, setPincode] = useState(currEvent.location.pincode);
  const [country, setCountry] = useState(currEvent.location.country);
  const [title, setEventName] = useState(currEvent.title);
  const [description, setEventDescription] = useState(currEvent.description);
  const initialDate = currEvent.date.slice(0, 10);
  const [date, setDate] = useState(initialDate);
  const [time, setTime] = useState(currEvent.time);
  const [ticketPrice, setPrice] = useState(currEvent.ticketPrice);
  const [numberOfTickets, setTotalTickets] = useState(currEvent.numberOfTickets);
  const [duration, setDuration] = useState();
  const [email, setEmail] = useState(userInfo.email);
  const [tag, setSelectedOption] = useState(currEvent.tag);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [ libraries,setLibraries ] = useState(['places']);

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };


  const inputRef = useRef();

  const handlePlaceChange = () => {
    const [place] = inputRef.current.getPlaces();
    if (place) {
      const addressComponents = place.address_components || [];
  
      let address = '';
      let city = '';
      let postcode = '';
      let country = '';

      console.log(addressComponents)
  
      for (const component of addressComponents) {
        const types = component.types || [];

        if (types.includes('street_number')) {
          address += component.long_name + ' ';
        }
  
        if (types.includes('street_address') || types.includes('premise') || types.includes('route')) {
          address += component.long_name;
        }
  
        if (types.includes('locality') || types.includes('postal_town')) {
          city = component.long_name;
          setCity(city)
        }
  
        if (types.includes('postal_code')) {
          postcode = component.long_name;
          setPincode(postcode)
        }
  
        if (types.includes('country')) {
          country = component.long_name;
          setCountry(country)
        }
      }
      
      setAddress(address)
      setLatitude(place.geometry.location.lat())
      setLongitude(place.geometry.location.lng())

      console.log('Address:', address);
      console.log('City:', city);
      console.log('Postcode:', postcode);
      console.log('Country:', country);
    }
  };
  


  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyC87PT659RDn0iG3G4G-lDOHQK7wUw6txc',
    libraries: libraries,
  });


  const handleIncreaseDuration = () => {
    if (minutes < 50) {
      setMinutes((prev) => prev + 10);
    } else {
      setMinutes(0);
      setHours((prev) => prev + 1);
    }
  
    var total = (hours * 60) + minutes + 10; 
  
    setDuration(total);
  };

  const handleDecreaseDuration = () => {
    if (minutes > 0) {
      setMinutes((prev) => prev - 10);
    } else if (hours > 0) {
      setHours((prev) => prev - 1);
      setMinutes(50);
    }
  
    var total = (hours * 60) + minutes - 10; 
  
    setDuration(total);
  };

  const handleCrossButton = () => {
    handleEditEvent();
  };

  const handleEditButton = async () => {
    const body = {
      title,
      email,
      description,
      tag,
      date,
      time,
      ticketPrice,
      numberOfTickets,
      location: {
        address,
        city,
        country,
        pincode,
        latitude,
        longitude,
      },
      duration
    };
    try {
      await axios.put(`https://event-finder12.onrender.com/events/editevent/${currEvent._id}`, body);

     
        setEvents(prevEvents => prevEvents.map(event => 
          event._id === currEvent._id ? { ...event, ...body } : event
        ));
  

      getExpiredEvents(userInfo.email);
      toast.success('Successfully edited the event')
      handleEditEvent();

    } catch (err) {
      console.log(err);
      toast.error(err.message)
    }
  };



  return (
    <div className="create-event-outer-container">
      <div className="create-event-container">
      <div className="create-event-header">
          <h3>Edit Event</h3>
          <div onClick={handleCrossButton} className="cross-mark">
            <FontAwesomeIcon icon={faXmark} />
          </div>
        </div>
        <div className="create-event-title">
          <h4>Event name & description</h4>
          <div className="create-event-forms">
            <input
              value={title}
              onChange={(e) => setEventName(e.target.value)}
              type="text"
              placeholder="Enter event name"
            />
            <div className="description">
              <textarea
                onChange={(e) => setEventDescription(e.target.value)}
                placeholder="Enter event description"
                className="description-textarea"
                value={description}
              />
            </div>
          </div>
        </div>
        <div className="create-event-timings">
          <div className="create-event-input">
            <h4>Date</h4>
            <input
              value={date}
              onChange={(e) => setDate(e.target.value)}
              type="date"
            />
          </div>
          <div className="create-event-input">
            <h4>Time</h4>
            <input
              value={time}
              onChange={(e) => setTime(e.target.value)}
              type="time"
            />
          </div>
          <div>
            <h4>Duration</h4>
            <div className="create-event-duration-input">
              <h4>
                {hours}h:{minutes}m
              </h4>
              <div className="duration-arrows">
                <FontAwesomeIcon
                  onClick={handleIncreaseDuration}
                  className="duration-arrow"
                  icon={faChevronUp}
                />
                <FontAwesomeIcon
                  onClick={handleDecreaseDuration}
                  className="duration-arrow"
                  icon={faChevronDown}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="create-event-location-container-row">
        <div className="create-event-location-container">
          <h4>Address</h4>
            {isLoaded && <StandaloneSearchBox onLoad={ref => (inputRef.current = ref)}
            onPlacesChanged={handlePlaceChange} >
                <input value={address} onChange={(e) => setAddress(e.target.value)} className="autocomplete-input" type="text" placeholder="Enter Address" />
            </StandaloneSearchBox>}
           

          
        </div>
        <div  className="create-event-location-container">
          <h4>City</h4>
          <input
            type="text"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            placeholder="Enter city"
          />

        </div>
        </div>

        <div className="create-event-location-container-row">
        <div className="create-event-location-container">
          <h4>Post Code</h4>
          <input
            type="text"
            value={pincode}
            onChange={(e) => setPincode(e.target.value)}
            placeholder="Enter postcode"
          />
          
        </div>
        <div className="create-event-location-container">
          <h4>Country</h4>
          <input
            type="text"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            placeholder="Enter Country"
          /> 
        </div>
        </div>
        <div className="create-event-price-container">
          <div className="ticket-details-div-container">
            <div className="ticket-details-create-container ">
              <h4>Price per ticket</h4>
              <input min={0} value={ticketPrice} onChange={(e) => setPrice(e.target.value)} type="number" />
              
            </div>
            <div className="ticket-details-create-container">
              <h4>Total Tickets</h4>
              <input min={10} value={numberOfTickets} onChange={(e) => setTotalTickets(e.target.value)} type="number" />
            </div>
          </div>
        </div>

        <div>
          <h4 className="create-event-tag">Tag</h4>
          <select
            id="selectOption"
            className="event-button create-event-tag-select"
            value={tag}
            onChange={handleSelectChange}
          >
            <option value="Music">Music</option>
            <option value="Sports">Sports</option>
            <option value="Job Event">Job Event</option>
            <option value="Charity Event">Charity Event</option>
            <option value="Religious Event">Religious Event</option>
          </select>
        </div>
        <div className="create-button-container">
          <div onClick={handleEditButton} className="create-event-button">Edit</div>
        </div>
      </div>
    </div>
  );
};

export default EditEvent;
